<template>
  <list-template :class="'height__100vh'">
    <template #header>
      <main-header>
        <template #filterByStatus>
          <div
            class="header-title wrapper-content__main font-size__large font-weight__bold"
          >
            Quản lý danh mục
          </div>
        </template>
      </main-header>
    </template>
    <template #view>
      <div class="view">
        <list-template :classCustom="'list-docs wrapper-content__main'">
          <template #subHeader>
            <sub-header>
              <template #content>
                <div class="leftSection">
                  <el-button
                    size="medium"
                    type="success"
                    class="createNew"
                    @click="isOpenDialog = true"
                  >
                    <div class="flex-row flex__center">
                      <i class="fas fa-plus-circle font-size__large"></i>
                      <span>&nbsp;&nbsp;THÊM MỚI</span>
                    </div>
                  </el-button>
                </div>
                <div class="flex-row flex__right">
                  <search
                    :keyword="searchForm.keyword"
                    :isDisableAdvanceSearch="true"
                    @simpleSearch="simpleSearch"
                  >
                    <template #quickFilter>
                      <el-row :gutter="24">
                        <el-col :span="12">
                          <el-select
                            class="style-fullWidth input-border__bottom input-border__radius__0 padding-right-5"
                            v-model="searchForm.deptId"
                            placeholder="-"
                            size="medium"
                            @change="deptIdChanged"
                          >
                            <el-option
                              v-for="item in departments"
                              :key="item.id"
                              :label="item.deptName"
                              :value="item.id"
                            ></el-option>
                          </el-select>
                        </el-col>
                        <el-col :span="6">
                          <el-select
                            class="input-border__bottom input-border__radius__0 padding-right-5"
                            v-model="searchForm.type"
                            placeholder="Cộng/trừ điểm"
                            size="medium"
                            clearable
                            @change="typeChanged"
                          >
                            <el-option
                              v-for="item in typeOptions"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                        </el-col>
                        <el-col :span="6">
                          <el-select
                            class="input-border__bottom input-border__radius__0 padding-right-5"
                            v-model="searchForm.scoreType"
                            placeholder="Loại"
                            size="medium"
                            clearable
                            @change="scoreTypeChanged"
                          >
                            <el-option
                              v-for="item in scoreTypeOptions"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                        </el-col>
                      </el-row>
                    </template>
                  </search>
                </div>
              </template>
            </sub-header>
          </template>
          <template #body>
            <div class="list">
              <!-- header-title -->
              <div class="header-title flex-row flex__between margin-bottom-10">
                <div class="leftSection flex-row flex__left">
                  <div class="theTitle theTitle__lv5">
                    <span class="stt padding-left-10">STT</span>
                  </div>
                  <div
                    class="theTitle theTitle__lv2 flex-row flex__left clickable"
                    @click="doSort('name')"
                  >
                    Tên
                    <sort-caret
                      :order="pageable.order"
                      :sort="pageable.sort"
                      :field="'name'"
                    />
                  </div>

                  <div
                    class="theTitle theTitle__lv1 flex-row flex__left clickable"
                  >
                    Mô tả
                  </div>
                </div>
                <div class="rightSection flex-row flex__left">
                  <div
                    class="theTitle theTitle__lv3 flex-row flex__left padding-left-10 clickable"
                    @click="doSort('code')"
                  >
                    Mã lý do
                    <sort-caret
                      :order="pageable.order"
                      :sort="pageable.sort"
                      :field="'code'"
                    />
                  </div>
                  <div
                    class="theTitle theTitle__lv3 flex-row flex__left padding-left-10 clickable"
                    @click="doSort('type')"
                  >
                    Cộng/trừ
                    <sort-caret
                      :order="pageable.order"
                      :sort="pageable.sort"
                      :field="'type'"
                    />
                  </div>
                  <div
                    class="theTitle theTitle__lv3 flex-row flex__left padding-left-10 clickable"
                    @click="doSort('scoreType')"
                  >
                    Loại
                    <sort-caret
                      :order="pageable.order"
                      :sort="pageable.sort"
                      :field="'scoreType'"
                    />
                  </div>
                  <div
                    class="theTitle theTitle__lv3 flex-row flex__center padding-left-10 clickable"
                  >
                    Trạng thái
                  </div>
                </div>
              </div>
              <!-- list-docs -->
              <vue-perfect-scrollbar
                class="scroll-area"
                :settings="perfectScrollbarSetting"
                infinite-wrapper
              >
                <div class="list-docs">
                  <div
                    v-for="(item, $itemIndex) in items"
                    v-bind:key="$itemIndex"
                    class="item flex-row flex__between"
                    @click="viewDetail(item)"
                  >
                    <div class="leftSection flex-row flex__left">
                      <div class="theTitle__lv5">
                        <div class="flex-row flex__left">
                          <div class="section-check">
                            <span class="stt flex-row flex__center">{{
                                $itemIndex + 1
                              }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="theTitle__lv2">
                        <div class="title-docs flex-col flex__left">
                          <div class="tt_1 clickable">
                            {{ item.name }}
                          </div>
                        </div>
                      </div>
                      <div class="theTitle__lv1">
                        <div class="title-docs flex-col flex__left">
                          <div
                            class="tt_1 clickable"
                            style="font-weight: lighter"
                            :title="item.note"
                          >
                            {{ getNoteShort(item.note) }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="rightSection flex-row flex__right">
                      <div
                        class="theTitle__lv3 flex-row flex__left padding-left-10 font-size__small"
                      >
                        <div class="flex-row flex__right">
                          {{ item.code }}
                        </div>
                      </div>
                      <div
                        class="theTitle__lv3 flex-row flex__left padding-left-10 font-size__small"
                      >
                        <div class="flex-row flex__left">
                          {{ getTypeLabel(item.type) }}
                        </div>
                      </div>
                      <div
                        class="theTitle__lv3 flex-row flex__left padding-left-10 font-size__small"
                      >
                        <div class="flex-row flex__left">
                          {{ getScoreTypeLabel(item.scoreType) }}
                        </div>
                      </div>
                      <div
                        class="theTitle__lv3 flex-row flex__center padding-left-10 font-size__small"
                      >
                        <el-tag
                          :type="
                            item.status === STATUS_.ACTIVE
                              ? 'success'
                              : 'danger'
                          "
                        >{{ getStatusLabel(item.status) }}
                        </el-tag>
                      </div>
                    </div>
                  </div>
                  <infinite-loading
                    ref="infiniteLoading"
                    spinner="spiral"
                    @infinite="infiniteHandler"
                  >
                    <div slot="no-more"></div>
                    <div slot="no-results">Không tìm thấy kết quả nào</div>
                  </infinite-loading>
                </div>
              </vue-perfect-scrollbar>
            </div>
          </template>
        </list-template>
      </div>
      <ranking-reason-dialog
        :isOpen="isOpenDialog"
        :id="selectedId"
        v-if="isEnableDialog"
        @closed="isEnableDialog = false"
        @closeDialog="isOpenDialog = false"
        @insertSuccess="insertSuccess"
        @updateSuccess="updateSuccess"
        @deleteSuccess="deleteSuccess"
      >
      </ranking-reason-dialog>
    </template>
  </list-template>
</template>

<script>
import ListTemplate from "../../common/list";
import MainHeader from "../../../components/header/main-header";
import SubHeader from "../../../components/main/sub-header";
import Search from "../../common/search";
import utils from "../../../services/utils";
import rankingReasonService from "../../../services/rankingReasonService";
import departmentService from "../../../services/departmentService";
import constants from "../../../constants";
import SortCaret from "../../doc-out/SortCaret";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import RankingReasonDialog from "./ranking-reason-dialog";
import rankingUtils from "../../../services/rankingUtils";

export default {
  name: "ranking-reason-index",
  components: {
    RankingReasonDialog,
    SortCaret,
    Search,
    SubHeader,
    MainHeader,
    ListTemplate,
    VuePerfectScrollbar
  },
  data() {
    return {
      pageable: {
        page: 0,
        size: 10,
        sort: "updateTime",
        order: "desc"
      },
      items: [],
      searchForm: {
        deptId: null,
        keyword: null,
        type: null,
        scoreType: null
      },
      departments: [],
      typeOptions: [],
      scoreTypeOptions: [],
      isOpenDialog: false,
      isEnableDialog: false,
      selectedId: null,
      STATUS_: constants.STATUS_,
      perfectScrollbarSetting: {maxScrollbarLength: 350}
    };
  },

  computed: {
    userDeptRole() {
      return this.$store.getters.userDeptRole;
    }
  },

  watch: {
    isOpenDialog(newValue) {
      newValue ? (this.isEnableDialog = newValue) : (this.selectedId = null);
    }
  },

  created() {
    if (!this.userDeptRole) return;
    this.initOptions();
    this.initQuery();
    this.loadDepartments();
  },

  methods: {

    getNoteShort(str) {
      return utils.getShortString(str, {
        maxLength: 200
      })
    },

    viewDetail(item) {
      this.selectedId = item.id;
      this.isOpenDialog = true;
    },

    insertSuccess() {
      this.isOpenDialog = false;
      this.doSearch();
    },

    updateSuccess() {
      this.isOpenDialog = false;
      this.doSearch();
    },

    deleteSuccess() {
      this.isOpenDialog = false;
      this.doSearch();
    },

    getTypeLabel(type) {
      return rankingUtils.getTypeLabel(type);
    },

    getStatusLabel(status) {
      return status === constants.STATUS_.ACTIVE
        ? "Hoạt động"
        : "Không hoạt động";
    },

    getScoreTypeLabel(type) {
      return rankingUtils.getScoreTypeLabel(type);
    },

    deptIdChanged() {
      this.doSearch();
    },

    scoreTypeChanged() {
      this.doSearch();
    },

    typeChanged() {
      this.doSearch();
    },

    loadDepartments() {
      return departmentService
        .findAllCurrentAndIncludeSubDepts()
        .then(response => (this.departments = response.data));
    },

    initOptions() {
      this.typeOptions = [
        {
          value: constants.RANKING_REASON.TYPE.CONGDIEM,
          label: this.getTypeLabel(constants.RANKING_REASON.TYPE.CONGDIEM)
        },
        {
          value: constants.RANKING_REASON.TYPE.TRUDIEM,
          label: this.getTypeLabel(constants.RANKING_REASON.TYPE.TRUDIEM)
        }
      ];

      this.scoreTypeOptions = [
        {
          value: constants.RANKING_REASON.SCORE_TYPE.CHUYENMON,
          label: this.getScoreTypeLabel(
            constants.RANKING_REASON.SCORE_TYPE.CHUYENMON
          )
        },
        {
          value: constants.RANKING_REASON.SCORE_TYPE.NGUYENTAC,
          label: this.getScoreTypeLabel(
            constants.RANKING_REASON.SCORE_TYPE.NGUYENTAC
          )
        }
      ];
    },

    initQuery() {
      let deptId = this.$route.query.deptId || undefined;
      if (!deptId) deptId = this.userDeptRole.deptId;

      this.searchForm = {
        deptId: deptId,
        keyword: this.$route.query.keyword || undefined,
        type: this.$route.query.type || undefined,
        scoreType: this.$route.query.scoreType || undefined
      };
    },

    buildQuery() {
      return utils.merge(
        {sort: this.pageable.sort, order: this.pageable.sort},
        this.searchForm
      );
    },

    simpleSearch(keyword) {
      this.searchForm.keyword = keyword;
      this.doSearch();
    },

    doSort(sort) {
      this.pageable.sort = sort;
      this.pageable.order =
        sort === this.pageable.sort
          ? this.pageable.order === "asc"
          ? "desc"
          : "asc"
          : "asc";
      this.doSearch();
    },

    doSearch() {
      //store query params at location-url
      this.$router.replace({
        name: this.$router.name,
        params: this.$route.params,
        query: this.buildQuery()
      });

      this.items = [];
      this.pageable.page = 0;

      this.$nextTick(
        () =>
          this.$refs.infiniteLoading &&
          this.$refs.infiniteLoading.stateChanger.reset()
      );
    },

    infiniteHandler($state) {
      this.list().then(items => {
        this.pageable.page += 1;
        items && items.length ? $state.loaded() : $state.complete();
      });
    },

    list() {
      let pageable = utils.convertPageableToSubmit(this.pageable);
      return rankingReasonService
        .findAll(this.searchForm, pageable)
        .then(response => {
          let items = response.data;
          items && this.items.push(...items);
          return items;
        });
    }
  }
};
</script>

<style scoped>
.leftSection {
  width: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/views/adminstration/reason/ranking-reason-index.vue